import { getTokensFromDocument } from './getTokensFromDocument';
import { replaceTokenWithHandlebars } from './replaceTokenWithHandlebars';

export const replaceTokensWithHandlebars = (htmlStr: string) => {
  const doc = new DOMParser().parseFromString(htmlStr, 'text/html');
  getTokensFromDocument(doc).forEach(replaceTokenWithHandlebars);
  return doc.body.innerHTML;
};
